import React from "react";

export const loginPopup = () => {
  return (
    <div className="loginloader">
      <svg
        width="48"
        height="48"
        viewBox="0 0 49 49"
        fill="transparent"
        xmlns="http://www.w3.org/2000/svg"
        color="transparent"
        className=""
      >
        <rect
          x="0.287109"
          y="0.832031"
          width="48"
          height="48"
          rx="24"
          fill="#FEF0C7"
        ></rect>
        <g clip-path="url(#clip0_12264_201)">
          <path
            d="M24.2879 20.8322V24.8322M24.2879 28.8322H24.2979M22.5779 15.6922L14.1079 29.8322C13.9332 30.1347 13.8408 30.4775 13.8399 30.8268C13.8389 31.176 13.9294 31.5194 14.1023 31.8228C14.2752 32.1262 14.5246 32.379 14.8256 32.5561C15.1266 32.7332 15.4687 32.8284 15.8179 32.8322H32.7579C33.1071 32.8284 33.4492 32.7332 33.7502 32.5561C34.0511 32.379 34.3005 32.1262 34.4734 31.8228C34.6464 31.5194 34.7369 31.176 34.7359 30.8268C34.7349 30.4775 34.6425 30.1347 34.4679 29.8322L25.9979 15.6922C25.8196 15.3983 25.5686 15.1554 25.2691 14.9867C24.9695 14.8181 24.6316 14.7295 24.2879 14.7295C23.9441 14.7295 23.6062 14.8181 23.3067 14.9867C23.0071 15.1554 22.7561 15.3983 22.5779 15.6922Z"
            stroke="#DC6803"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_12264_201">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(12.2871 12.832)"
            ></rect>
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
